import '../styles/components/Projects.css';
import { m } from 'framer-motion';
import { fadeUp, staggerContainer, staggerItem, viewport } from '../motion/variants';

const projects = [
  {
    title: 'Road Construction Material Supply & Support',
    imageSrc: '/img/abl10.jpeg',
    description:
      'We provide high-quality construction aggregates, kokoto, sand, and other essential materials for road construction projects, ensuring durability, strength, and reliable project support.',
  },
  {
    title: 'Residential Building Material Supply',
    imageSrc: '/img/abl11.jpeg',
    description:
      'ABL Construction Limited supplies trusted building materials for residential projects, including cement, sand, blocks, and concrete materials to support safe and strong home construction.',
  },
  {
    title: 'Commercial Project Logistics & Transportation',
    imageSrc: '/img/abl12.jpeg',
    description:
      'We offer dependable logistics and transportation services for commercial construction projects, ensuring timely delivery of materials and efficient coordination across project sites.',
  },
  {
    title: 'Kokoto & Aggregate Supply for Infrastructure Projects',
    imageSrc: '/img/abl9.jpeg',
    description:
      'We supply premium-quality kokoto and aggregates suitable for infrastructure developments such as foundations, drainage systems, concrete works, and large-scale construction projects.',
  },
];

function Projects() {
  return (
    <section className="projects" id="projects">
      <div className="projects-inner">
        <m.header
          className="projects-header"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={fadeUp}
        >
          <h2>Projects</h2>
          <p>
            A snapshot of the kinds of projects we support across Tanzania through quality material
            supply and reliable logistics.
          </p>
        </m.header>

        <m.div
          className="projects-grid"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={staggerContainer}
        >
          {projects.map((project) => (
            <m.article
              className="project-card"
              key={project.title}
              variants={staggerItem}
              whileHover={{ y: -4 }}
              transition={{ type: 'spring', stiffness: 400, damping: 28 }}
            >
              <div className="project-media" aria-hidden="true">
                <img src={project.imageSrc} alt="" loading="lazy" />
              </div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </m.article>
          ))}
        </m.div>
      </div>
    </section>
  );
}

export default Projects;
